<template>
  <div class="view">
    <Title title="イベント(クローズド)"/>
    <EventClosedMain/>
  </div>
</template>

<script>
import Title from '@/components/Title.vue'
import EventClosedMain from '@/components/EventClosedMain'

export default {
  components: {
    Title,
    EventClosedMain
  },

  created: function () {
    this.$store.dispatch('eventClosed/retrieve')
  }
}
</script>

